import React, { Component } from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { Controller } from '../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';
import { SearchBar } from '../../common/components/SearchBar';

export class Products extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Products'
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['products'], { state: 'INIT', pb: 'fieldDef' }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['brands']) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'cats']) },
    ]
    this.tableHeadersMap = {
      'Slug / ID': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.slug}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{current.id}</span>
          </div>
        )
      },
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
  }

  onFetchSuccess(results) {
    this.fieldDef = results[0].fieldDef
    this.formDefinition = results[0].fieldDef
    AppHelper.populateOptions(this.formDefinition, results[1], 'brandId')

    const catsById = Helper.itemsToMap(results[2].items, 'id')
    const leafCats = []
    results[2].items.forEach(i => {
      i.parents = []
      if (i.parentId) {
        const parentL2 = catsById[i.parentId]
        if (parentL2 && parentL2.parentId) {
          const parentL1 = catsById[parentL2.parentId]
          if (parentL1) {
            leafCats.push({
              parents: [parentL1, parentL2],
              id: i.id,
              title: parentL1.title + '/' + parentL2.title + '/' + i.title
            })
          }
        }
      }
    })
    AppHelper.populateOptions(this.formDefinition, { items: leafCats}, 'catIds')

    this.setState({
      items: results[0].items,
    })
  }

  renderAboveTable() {
    return (
      <SearchBar
        onSearch={this.onSearch.bind(this)}
        onList={this.onList.bind(this)}
        searchText={this.state.searchText}>
      </SearchBar>
    )
  }

  onSearch = (searchText) => {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      searchText: searchText,
    })
    ApiHelper.call({
      method: 'get', paths: ['miscs', 'search-deep'], queryParams: { title: searchText }}, (err, result) => {
      if(err) {
        console.log('Search Error', err)
      }
      const items = result ? result.items : []
      this.setState({
        items: items,
        fetchState: ApiHelper.State.READY,
        nextPage: ''
      })
    })
  }

  onList = () => {
    this.fetchItems()
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['products'], {}),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['products', current.id], {}),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonOpenProduct(this, current))
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Products.js